export default __webpack_public_path__ + "static/media/appointmentTrackers.c788a9ff.png";